/* eslint-disable arrow-body-style */
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { MainBodyContainer } from './Equipments.styles';
import EquipmentHeader from './EquipmentHeader';
import Loader from '../../component/Loader/Loader';
import TabsTable from '../../component/Common/Tabs_Table';
import { isEmpty } from '../../shared/utility/isEmpty';
import Toast from '../../component/Common/Toast';
import { useActions } from '../../store/hooks/useActions';
import { apiEndPoints } from '../../services/axios/endPoints';
import { sagaCatchBlockHandling } from '../../store/utility/sagaErrorHandling';
import { WebService } from '../../services/axios/webServices';
import { fetchUserAndLocation } from '../../component/Sidenav/fetchPageStatistics';

const Equipments = () => {
  const pageSize = 20;
  const [assetShortlist, setAssetShortlist] = useState([]);
  const navigate = useNavigate();

  const { userData } = useSelector((state) => state.loginData);
  const { finalMenu } = useSelector((state) => state.home);
  const location = useLocation();
  useEffect(() => {
    const name = finalMenu.find((ele) => ele.path === location.pathname);
    fetchUserAndLocation(location.pathname, userData, {
      pageType: name?.name
    });
  }, []);

  const {
    equipmentsData,
    equipmentsMeta,
    equipmentPermissions,
    loading,
    error,
    equipmentsCount,
    searchQueries
  } = useSelector((state) => state.equipmentDetails);

  const {
    getEquipmentsListFailure,
    setSearchQueries,
    getEquipmentsList,
    setToastError
  } = useActions();

  const rowOptions = equipmentPermissions?.CanEdit
    ? [{ id: 1, label: 'Edit details', value: 'editDetails' }]
    : [];

  const selectionTypeandPosition = {
    isCheckboxTypeSelection: true,
    isSelectionAtFirst: true
  };

  const handlePageChange = (page, rest = {}) => {
    const { searchParams } = rest;
    getEquipmentsList({ page, pageSize, searchParams });
  };

  const setAssetSearchQueries = (searchQueries) => {
    setSearchQueries(searchQueries || {});
  };

  useEffect(() => {
    handlePageChange(1);

    return () => {
      setSearchQueries();
    };
  }, []);

  const clearError = () => {
    getEquipmentsListFailure('');
  };

  const handleEquipmentCreate = () => {
    navigate('/home/Equipment/add', {
      state: {
        isFormEditable: true,
        formInput: {},
        formApi: `${apiEndPoints.getEquipmentForm}/EquipmentForm`,
        saveForm: `${apiEndPoints.updateEquipment}/new`
      }
    });
  };

  const handleShowDetails = (ele) => {
    WebService.get(`${apiEndPoints.getEquipmentDetail}/${ele?.Id}`)
      .then((res) => {
        const { status, data } = res;
        if (status >= 200 && status < 300) {
          navigate('/home/Equipment/details', {
            state: {
              formInput: data,
              isFormEditable: false,
              formApi: `${apiEndPoints.getEquipmentForm}/UpdateEquipmentForm`,
              saveForm: `${apiEndPoints.updateEquipment}/update`
            }
          });
        } else {
          throw res.data;
        }
      })
      .catch((e) => {
        const { error } = sagaCatchBlockHandling(e);
        setToastError(error);
      })
      .finally(() => {
        // setLoading(false);
      });
  };

  const handleRowOptionsItemClick = ({ value }, { activeRowItem }) => {
    if (value === 'editDetails') {
      WebService.get(`${apiEndPoints.getEquipmentDetail}/${activeRowItem?.Id}`)
        .then((res) => {
          const { status, data } = res;
          if (status >= 200 && status < 300) {
            navigate('/home/Equipment/edit', {
              state: {
                isFormEditable: true,
                formInput: data,
                formApi: `${apiEndPoints.getEquipmentForm}/UpdateEquipmentForm`,
                saveForm: `${apiEndPoints.updateEquipment}/update`
              }
            });
          } else {
            throw res.data;
          }
        })
        .catch((e) => {
          const { error } = sagaCatchBlockHandling(e);
          setToastError(error);
        })
        .finally(() => {
          // setLoading(false);
        });
    }
  };

  return (
    <>
      <MainBodyContainer>
        <EquipmentHeader
          hasBack={false}
          title='Equipment'
          isCreate
          canAdd={!!equipmentPermissions?.CanAdd}
          canEdit={equipmentPermissions?.CanEdit}
          handleEquipmentCreate={handleEquipmentCreate}
          handlePageChange={handlePageChange}
          pageSize={pageSize}
          equipmentsCount={equipmentsCount}
        />
        {loading ? (
          <Loader />
        ) : (
          <TabsTable
            metaDetails={equipmentsMeta}
            dataDetails={equipmentsData}
            showPagiation={false}
            showShortlistSelection={false}
            onItemSelect={handleShowDetails}
            assetShortlist={assetShortlist}
            handlePageChange={handlePageChange}
            styleType='strapedTable'
            noItemsFoundMessage='No Equipments Found'
            rowOptions={!isEmpty(rowOptions) && rowOptions}
            showRowOptionAtStart={false}
            id='Id'
            handleRowOptionsItemClick={handleRowOptionsItemClick}
            shortListSelectionDetails={selectionTypeandPosition}
            saveSearchQueries={setAssetSearchQueries}
            savedSearchQueries={searchQueries}
            resetSearchQueries={setAssetSearchQueries}
          />
        )}
      </MainBodyContainer>
      {error && (
        <Toast
          header='Error'
          className='fixed right'
          message={error}
          fn={clearError}
        />
      )}
    </>
  );
};

export default Equipments;
